import React from 'react';
import { Input, Button, DatePicker } from 'components';
import { SurveyService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals } from 'utils';
import moment from 'moment';

interface Props {
	title?: string;
	onClose?: any;
	item?: any;
}

class ViewSurvey extends React.Component<Props> {

	state = {
		survey: null
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await SurveyService.admin.view({
			survey_id: this.props.item?.id
		});
		this.setState({
			survey: res.survey
		});
	}

	calculatePercent = (item: any, responses_quantity: number) => {
		try {
			// @ts-ignore
			const quantity = responses_quantity / item?.options?.map((i: any) => i.responses_quantity).reduce((a: number, b: number) => a + b,0);
			if (isNaN(quantity)) {
				return 0;
			}
			else {
				return (quantity * 100).toFixed(2);
			}
		}
		catch(e) {
			return 0;
		}
	}
	
	render() {
		const survey: any = this.state.survey;

		return (
			<div id="modal-view-survey">
				{
					survey != null && (
						<>
							<div className="row">
								<div className="col-md-6">
									<p className="label">Nombre</p>
									<p>{ survey?.name }</p>
								</div>
								<div className="col-md-6">
									<p className="label">Fecha de Expiración</p>
									<p>{ moment(survey?.expiration_date).format('DD/MM/YYYY') }</p>
								</div>
							</div>
							<div className="row row-title">
								<div className="col-md-8">
									<h3>Preguntas</h3>
								</div>
							</div>
							{
								survey?.questions?.map((item: any, index: number) => {
									return (
										<>
											<div className="container-question">
												<h4>{ index + 1 }. { item?.name }</h4>
											</div>
											{
												item?.options?.map((option: any, option_index: number) => {
													const percent = this.calculatePercent(item,option?.responses_quantity);

													return (
														<div className="container-response">
															<div style={{ width: '100px' }}>
																<h5>{ option?.name }</h5>
																<p className="bold">{ option?.responses_quantity } Votos</p>
																<p className="bold">({ percent }%)</p>
															</div>
															<div className="bar" style={{ width: percent + '%', minWidth: '1%' }}></div>
														</div>
													)
												})
											}
										</>
									)
								})
							}
						</>
					)
				}
			</div>
		)
	}
}

export default ViewSurvey;